import React from "react";

export default function InvestmentDisclaimer({ className = "" }) {
  return (
    <div
      data-testid="investment-disclaimer"
      className={`max-w-4xl ${className}`}
    >
      <div className="evg-overline">Investment Disclaimer</div>
      <p className="mt-5 text-[13px] leading-[1.85] text-[#0A1F44]/65 font-light max-w-3xl">
        Information contained on this website is provided for discussion and informational purposes
        only and does not constitute an offer to sell or a solicitation to purchase securities or
        investment products. Any investment opportunity is subject to formal documentation, due
        diligence, regulatory requirements and applicable laws.
      </p>
    </div>
  );
}
